import { useQuery } from '@tanstack/react-query'
import { getQcTaskMetadataQcTasksQcTaskIdMetadataGet, QcTaskMetadataSchema } from '@common/config/api/client'
import { queryKeyFactory } from './queryKeyFactory'

export type GetQcTaskMetadataParams = {
  qc_task_id: string
  study_id: string
  is_previous_qc_task?: boolean
}

export const useGetQcTaskSubmissionMetadata = (params: GetQcTaskMetadataParams) => {
  return useQuery<QcTaskMetadataSchema, Error, QcTaskMetadataSchema>({
    queryKey: queryKeyFactory.qcTaskMetadata(params),
    queryFn: async () => {
      const response = await getQcTaskMetadataQcTasksQcTaskIdMetadataGet({
        path: {
          qc_task_id: params.qc_task_id,
        },
        query: {
          study_id: params.study_id,
          is_previous_qc_task: params.is_previous_qc_task,
        },
        throwOnError: true,
      })
      return response.data
    },
    enabled: !!params.qc_task_id && !!params.study_id,
  })
}
